import { initMessageLoader } from "./initMessageLoader";

/**
 * Clone the first message template of a given role, append it to the chat
 * content area, and show a loader. Returns the cloned element.
 *
 * @param {jQuery} chatForm - A .g-chatform element (or a descendant of one).
 * @param {string} [role="admin"] - The data-role value to clone (e.g. "admin", "user").
 * @returns {jQuery} The cloned message element (already appended and visible).
 */
export function appendMessageLoader(chatForm, role = "admin") {
  const chatRoot = chatForm.hasClass("g-chatform")
    ? chatForm
    : chatForm.closest(".g-chatform");

  const messageTemplate = chatRoot
    .find(`.g-chatform-message[data-role="${role}"]`)
    .first()
    .clone();

  chatRoot.find(".g-chatform-content").append(messageTemplate);

  messageTemplate.find(".g-chatform-message-inner").hide();
  messageTemplate.show();

  initMessageLoader(messageTemplate, chatRoot);

  return messageTemplate;
}
